import { makeStyles } from "@material-ui/core";

export const useFormStyle = makeStyles((theme) => ({
  form: {
    width: "100%",
  },
}));
